import { render, staticRenderFns } from "./rubric_form_actions.vue?vue&type=template&id=2a1912bf&scoped=true&"
import script from "./rubric_form_actions.vue?vue&type=script&lang=js&"
export * from "./rubric_form_actions.vue?vue&type=script&lang=js&"
import style0 from "./rubric_form_actions.vue?vue&type=style&index=0&id=2a1912bf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1912bf",
  null
  
)

export default component.exports